export enum TeamType {
  Store = "store",
  FulfillmentService = "3PL",
}
